var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSavedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 15L6.00037 11.2503L0.000368037 15V1.87515C-0.00937693 1.38786 0.17474 0.916632 0.512259 0.565021C0.849778 0.21341 1.31308 0.0101837 1.80037 0L10.2004 0C10.6877 0.0101837 11.151 0.21341 11.4885 0.565021C11.826 0.916632 12.0101 1.38786 12.0004 1.87515V15Z",
    fill: "#7B7BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 15L6.00049 11.25L0.000488281 15V1.875C0.000488281 0.839467 0.806373 0 1.80049 0H10.2005C11.1946 0 12.0005 0.839467 12.0005 1.875V15Z",
    fill: "#7B7BFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedIcon);
export default __webpack_public_path__ + "static/media/saved-icon.021a591b0b3cf836384bbc6a6e405483.svg";
export { ForwardRef as ReactComponent };